module.exports = __webpack_public_path__ + "static/img/qrcode.9513d40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/qrcode.jpg
// module id = /KaL
// module chunks = 3